module.exports = __webpack_public_path__ + "static/media/served.9c302eba.svg";